module.exports = __webpack_public_path__ + "img/icon_multiple_confirm.f2215e83.png";